import Products from './products';
import CustomPolygraphyProducts from './CustomPolygraphyProducts';
import AutoFlyerSettings from './AutoFlyerSettings';

export default {
  Products,
  CustomPolygraphyProducts,
  AutoFlyerSettings,
};
